import { StudentStoreSA } from "../../../react/students/StudentStoreSA"
import { Scale } from "../../utils/Scale"

export class TruthPos {

    static classStartY = () => Scale.x(0.05)
    static leaderStartY = () => Scale.x(0.148)

    static userEndX = () => StudentStoreSA.instance.isGirl() ? Scale.x(-0.23) : Scale.x(-0.32)

    static friendStartX = () => Scale.width()
    static friendEndX = () => Scale.width() * 0.765

    static introBubbleX = () => Scale.width() * 0.29
    static introBubbleY = () => Scale.height() * 0.15
    static introBubbleWidth = () => Scale.width() * 0.42
    static introBubbleHeight = () => Scale.height() * 0.65

}
